import { useEffect, useState } from 'react'
import { Box } from '@mui/system'
import { Typography } from '@mui/material'
import { useHistory } from 'react-router-dom'
import CompanyActionBtn from './CompanyActionBtn'
import ModulesWithHover from './ModulesWithHover'
import { companyButtonList } from '../../components/utils/buttonList'
import HoverTooltip from '../../components/PageHelpers/HoverTooltip.jsx'
import UseTranslation from '../../hooks/UseTranslation.jsx'

const CompanyCard = ({ data, onStatusChangeClick }) => {
  const history = useHistory()
  const [status, setStatus] = useState(null)
  const { t } = UseTranslation()
  useEffect(() => {
    if (data.company.active && !data.company.suspended) setStatus(companyButtonList[0])
    else if (!data.company.active && !data.company.suspended) setStatus(companyButtonList[1])
    else if (!data.company.active && data.company.suspended) setStatus(companyButtonList[2])
  }, [data])
  const goToCompanyProfile = (cardData) => {
    const { company } = cardData
    history.push({
      pathname: `/company/${company.id}`,
      state: { companyRow: cardData },
    })
  }

  return (
    <>
      <Box
        sx={[styles.singleCard, { cursor: 'pointer' }]}
        onClick={() => goToCompanyProfile(data)}
        role="button"
      >
        <Box sx={styles.infoUnit}>
          <Typography component={'span'}>{t?.['Company Name']}</Typography>
          <HoverTooltip title={data.company.name}>
          <Typography variant='body1'>
          {data.company.name || '---'}
          </Typography>
          </HoverTooltip>
        </Box>
      <Box sx={styles.infoUnit}>
          <Typography component={'span'}>{t?.['Company\'s Tenant']}</Typography>
          <HoverTooltip title={data.tenant.name}>
          <Typography variant='body1'>
          {data.tenant.name || '---'}
          </Typography>
          </HoverTooltip>
         </Box>

        <Box sx={styles.infoUnit}>
          <Typography component={'span'}>{t?.['Company\'s Modules']}</Typography>
          <ModulesWithHover
            companyName={data.company.name}
            modules={data.company.modules}
            customStyle={styles.modulesWithHover}
            />
        </Box>

        <Box sx={styles.infoUnit}>
          <Typography component={'span'}>{t?.Status}</Typography>
          <HoverTooltip title={t?.[status?.title]}>
          <Typography variant='body1' sx={{ color: status?.color }}>
          {t?.[status?.title] || '---'}
          </Typography>
          </HoverTooltip>
         </Box>

        <CompanyActionBtn
          data={data}
          status={status}
          statusButtonList={companyButtonList}
          onStatusChangeClick={onStatusChangeClick}
          onViewCompany={goToCompanyProfile}
          customStyle={styles.actionBtn}
        />

      </Box>
    </>
  )
}

const styles = {
  singleCard: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    fontSize: { xs: '14px', sm: '16px' },
    padding: '20px',
    paddingRight: { xs: '0px', sm: '50px' },
    margin: '10px 0',
    borderRadius: '12px',
    boxShadow: '0 1px 3px 0 #efefef, 0 0 0 1px #f1f1f1',
    flexDirection: { xs: 'column', sm: 'row' },
    position: { xs: 'relative', sm: 'unset' },
  },
  modulesWithHover: {
    '& p': {
      marginRight: '0px !important',
    },
  },
  infoContainer: {
    display: 'flex',
    flexDirection: { xs: 'row', sm: 'column' },
    justifyContent: { xs: 'flex-start', sm: 'center' },
    paddingRight: { xs: '0px', sm: 'unset' },
    width: '100%',
    textTransform: 'capitalize',
    alignItems: 'center',
    fontSize: { xs: '10px', sm: '12px' },
    span: {
      display: 'block',
      opacity: '0.7',
      fontSize: { xs: '12px', sm: '14px' },
      fontWeight: '500',
      color: 'text.hint',
      marginBottom: { xs: '0px', sm: '10px' },
      marginRight: { xs: '10px', sm: 'unset' },
    },
  },
  infoUnit: {
    display: 'flex',
    flexDirection: { xs: 'row', sm: 'column' },
    justifyContent: { xs: 'flex-start', sm: 'center' },
    maxWidth: '100%',
    width: '100%',
    minWidth: 0,
    alignItems: { xs: 'flex-start', sm: 'center' },
    '& p': {
      fontSize: { xs: '12px', sm: '16px' },
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 'fit-content',
      maxWidth: '100%',
      marginBottom: { xs: '5px', sm: '0px' },
    },
    '& span': {
      width: { xs: '150px', sm: 'fit-content' },
      fontSize: { xs: '12px', sm: '14px' },
      opacity: '0.7',
      fontWeight: '500',
      color: 'text.hint',
      marginBottom: '10px',
      marginRight: { xs: '10px', sm: '0px' },
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  actionBtn: {
    position: { xs: 'absolute', sm: 'unset' },
    top: { xs: '10px', sm: 'unset' },
    right: { xs: '0px', sm: 'unset' },
  },
}

export default CompanyCard
